import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      "stallions": "Stallions",
      "products": "Products",
      "champions": "Champions",
      "about1": "is a horse breeding center located near Meknes. The center has won several trophies in various competitions. The most recent is a gold medal at the 'Straight Egyptian Royal World Cup MILAN' competition. Thanks to the center, dozens of horses are born each year. These include several breeds, with a predominance of Pur-Sang Arab and Pur-Sang Arabe Straight Egyptians.",
      "about2": "The director of the center,",
      "about3": "An agricultural engineer, thanks to his forward-thinking vision and strong management, he make the center shine internationally.",
      "name": "Name",
      "phone": "phone",
      "send": "send",
      "contactMsg": "To contact us by e-mail you can send your message to the following address:",
      "father": "Father",
      "mother": "Mother",
      "borne": "Borne",
      "betterPrice": "Better price",
      "allPrices": "All prices",
      "champions": "Champions",
      "mister": "Mister",
      "directorOfHaras": "director of the Haras",
      "aboutDirector1": "He is an agricultural engineer who also holds the position of Deputy General Director of the Agricultural Division within the T-MAN Group. Mr. Tadlaoui has been able to bring to the stud farm the skills and techniques he developed during his engineering education and professional career.",
      "aboutDirector2": "Beyond his technical and managerial management of the stud farm, Mr. TADLAOUI is a passionate individual with a deep love for horses. He maintains a close and harmonious relationship with them.",
      "aboutDirector3": "has won several championships at both the national (Moroccan) and international levels. He has proudly represented the Moroccan flag on numerous occasions in various international competitions, winning several medals, including gold medals. His horses have also achieved high rankings in international standings.",
      "aboutDirector4": "The Director of the stud farm leads a dynamic and ambitious team composed of highly experienced senior professionals and motivated junior members who bring forward innovative ideas and suggestions. In this spirit, the Director does not hesitate to allocate the necessary financial and human resources in pursuit of excellence and to honor the Moroccan flag.",
      "excelence": "Excellence",
      "speed": "Speed",
      "elegance": "Elegance",
      "home": "Home",
      "prices": "Prices",
      "mares": "Mares"
    }
  },
  fr: {
    translation: {
      "stallions": "Etalons",
      "products": "Produits",
      "champions": "Champions",
      "about1": "est un centre d’élevage de chevaux situé à proximité de Meknès. Le centre a emporté plusieurs trophées dans différentes compétitions. Le dernier en date, est une médaille d'or dans la compétition 'Straight Egyptian Royal World Cup MILAN'. Grace au centre chaque année des dizains de chevaux voient le jour. Il s'agit de plusieurs races, avec une dominance des races Pur-Sang Arabe et Pur-Sang Arabe Straight Egyptians.",
      "about2": "Le directeur du centre,",
      "about3": "ingénieur agricole, a pu grace à sa vision avancée et sa bonne gestion faire rayonner le centre à l'échelle international.",
      "name": "Nom",
      "phone": "Téléphone",
      "send": "Envoyer",
      "contactMsg": "Pour nous contacter, Merci d'envoyer un message à l'adresse suivante :",
      "father": "Père",
      "mother": "Mère",
      "borne": "Né(e)",
      "betterPrice": "Meilleur prix",
      "allPrices" : "Tous les prix",
      "champions": "Champions",
      "mister": "Monsieur",
      "directorOfHaras": "le directeur du Haras",
      "aboutDirector1": "est un ingénieur Agronome, qui occupe aussi le poste de directeur général adjoint du pôle agricole au sein du groupe T-MAN. Monsieur TADLAOUI à pu mettre au service du Haras les competences et les techniques qu'il a developpées durant sa formation d'ingénieur et son parcours professionenel.",
      "aboutDirector2": "Au delà de sa gestion technique et managériale du Haras, Monsieur TADLAOUI est un passionné, qui a un grand amour pour les chevaux. Il entretien avec eux une relation étroite et harmonieuse.",
      "aboutDirector3": "a pu emporter plusieurs championnats à l'echelle Marocaine et internationnale. Il a honoré à mainte reprise le drapeau Marocain dans différentes compétitions internationnales en emportant plusieurs médailles y compris des medailles d'or. Ses chevaux ont pu aussi occuper des places avancées dans le classement international",
      "aboutDirector4": "Monsieur Le directeur du Hars travaille en tête d'une équipe dynamique et embitieuse regroupant des seniors très expérimentés et des juniors motivés, force de de proposition et porteurs d'idées inovantes. Ainsi, Monsieur le directeur n'hésite pas à mettre en place les ressources nécessaires sur le plan financier ou humain, afin de viser l'excelence et d'honorer le drapeau Marocain.",
      "excelence": "Excélence",
      "speed": "Vitesse",
      "elegance": "Elégence",
      "home": "Accueil",
      "prices": "Trophées",
      "mares": "Juments"
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;